import * as React from 'react'

const Scissors = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={26} viewBox="0 0 32 26" {...props}>
    <g id="Group_58908" data-name="Group 58908" transform="translate(3176 10176.537)">
      <path
        id="Ellipse_1989"
        data-name="Ellipse 1989"
        d="M4.915,2A2.915,2.915,0,1,0,7.831,4.915,2.919,2.919,0,0,0,4.915,2m0-2A4.915,4.915,0,1,1,0,4.915,4.915,4.915,0,0,1,4.915,0Z"
        transform="translate(-3176 -10175.546)"
        fill="#263238"
      />
      <path
        id="Ellipse_1990"
        data-name="Ellipse 1990"
        d="M4.915,2A2.915,2.915,0,1,0,7.831,4.915,2.919,2.919,0,0,0,4.915,2m0-2A4.915,4.915,0,1,1,0,4.915,4.915,4.915,0,0,1,4.915,0Z"
        transform="translate(-3176 -10160.368)"
        fill="#263238"
      />
      <path id="Path_92889" data-name="Path 92889" transform="translate(-3175.663 -10176.537)" fill="#263238" />
      <path
        id="Path_92891"
        data-name="Path 92891"
        d="M1.123,17.016,0,15.361,22.639,0l1.123,1.655Z"
        transform="matrix(0.999, -0.035, 0.035, 0.999, -3168.342, -10174.141)"
        fill="#263238"
      />
      <path
        id="Path_92892"
        data-name="Path 92892"
        d="M7.664,6.382,0,1.708,1.041,0,8.706,4.674Z"
        transform="matrix(0.999, 0.035, -0.035, 0.999, -3168.146, -10169.277)"
        fill="#263238"
      />
      <path
        id="Path_92893"
        data-name="Path 92893"
        d="M13.026,9.695.741,1.865,0,1.413,1.524,0l.284.173L14.1,8.008Z"
        transform="matrix(0.999, 0.035, -0.035, 0.999, -3158.351, -10162.507)"
        fill="#263238"
      />
    </g>
  </svg>
)
export default Scissors
